import React, { useEffect, useState } from 'react';
import getCookie from '../../utils/getCookies';
import { useEMSModalStyles } from './styles';
import { setCookie } from '../../utils/setCookie';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Link,
} from '@material-ui/core';

export default function EMSModal(): JSX.Element {
    const { classes } = useEMSModalStyles();
    const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        const viewed = getCookie('ems-modal-visualized');
        if (viewed !== 'true') setOpen(true);
    }, []);

    return (
        <Dialog
            open={open}
            onClose={setOpen}
            maxWidth='sm'
        >
            <DialogTitle classes={{ root: classes.titleRoot }}>
                Acesso ao sistema eMS
            </DialogTitle>
            <DialogContent className={classes.content} dividers>
                O sistema eMS possui uma forma de acesso exclusiva para servidores.
                <br />
                Para acessar, utilize seu acesso de rede.
            </DialogContent>
            <DialogActions className={classes.footer}>
                <Link
                    target='_blank'
                    rel='noopener noreferrer'
                    href='https://e-ms.ms.gov.br/callback/auth/login-govbr'
                    className={classes.linkButton}
                >
                    Acessar eMS
                </Link>
                <Button
                    type='button'
                    className={classes.closeButton}
                    onClick={() => {
                        setCookie('ems-modal-visualized', 'true');
                        setOpen(false);
                    }}
                >
                    Fechar
                </Button>
            </DialogActions>
        </Dialog>
    );
}
